import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { selectPrefix } from '../utility/Redux/profile';
import { useDispatch, useSelector } from 'react-redux';
import { selectToken } from '../utility/Redux/security';

import { FormatNumber2 } from '../utility/component/tools';
import { CollectionFromToDate } from '../utility/component/collectionFromToDate';

import {
  selectCustomerMasterHelpModStatus,
  setCustomerMasterHelpModStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import {
  setBookingAttachImage,
  setHistoryOrderDetails,
  setModifyingBookingId,
  setSelctedBookingUpperitemDetails,
  setSelectedBooingLowerItemDetails,
} from '../utility/Redux/booking';
import { setViewBillInvoiceId, setViewBillMod } from '../utility/Redux/billing';

import { CollectionFromToDateMobile } from '../utility/component/collectionFromToDateMobile';
import { useNavigate } from 'react-router-dom';
import PrintBillSummary from './printBillSummary';
import { useReactToPrint } from 'react-to-print';
import CustomerMasterhelp from '../help/customermasterHelp';
import { CallAPIPromise } from '../utility/func/func';
const width = window.innerWidth / 100;

const BillSummery = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);

  const dispatch = useDispatch();
  const [firstDate, setFirstDate] = useState(moment().format('YYYY-MM-DD'));
  const [SecondDate, setSecondDate] = useState(moment().format('YYYY-MM-DD'));

  const [customerInfo, setCustomerInfo] = useState({
    code: '',
    customer_name: '',
    mobile: '',
    mobile_2: '',
    mobile_3: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    credit_limit: 100000,
    company_name: '',
    company_phone: '',
    company_email: '',
    company_address: '',
    company_city: '',
    company_state: '',
    company_country: '',
    company_pincode: '',
    regd_no1: '',
    regd_no2: '',
    regd_no3: '',
    status: 'Good',
    remarks: '',
  });
  const [list, setList] = useState([]);

  const customerMasterModalStatus = useSelector(
    selectCustomerMasterHelpModStatus
  );

  const customerDetails = (params) => {
    dispatch(setBookingAttachImage(''));
    dispatch(setSelectedBooingLowerItemDetails(''));
    dispatch(setSelctedBookingUpperitemDetails(''));
    dispatch(setModifyingBookingId(''));
    setCustomerInfo(params.row);
    dispatch(setCustomerMasterHelpModStatus(false));
    dispatch(setHistoryOrderDetails(''));
  };

  const openBillPreview = (invoiceId) => {
    dispatch(setViewBillInvoiceId(invoiceId));
    dispatch(setViewBillMod(true));
  };

  const viewBillColumn = {
    field: 'VIEW_BILL',
    headerName: 'Action',
    width: 96,
    minWidth: 96,
    maxWidth: 96,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    headerAlign: 'center',
    align: 'center',
    headerClassName: 'super-app-theme--header',
    renderCell: (params) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          openBillPreview(params.row.INVNO);
        }}
        className="rounded-md border border-[#f5874f] bg-[#fff2eb] px-2.5 py-1 text-[11px] font-semibold text-[#dc6f39] transition hover:bg-[#f5874f] hover:text-white"
        aria-label={`View bill ${params.row.INVNO}`}
      >
        View Bill
      </button>
    ),
  };

  const columns = [
    {
      field: 'INVNO',
      type: 'number',
      width: 76,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      accessor: 'INVNO',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Invoice'}
        </div>
      ),
    },
    {
      field: 'BOOKING_ORDER_NO',
      accessor: 'BOOKING_ORDER_NO',
      type: 'number',
      width: 104,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Booking ID'}
        </div>
      ),
    },
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'string',
      width: 124,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      accessor: 'CUSTOMER_NAME',
      field: 'CUSTOMER_NAME',
      type: 'string',
      width: 168,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderCell: (params) => <div>{params.value || '—'}</div>,
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Customer Name'}
        </div>
      ),
    },
    {
      accessor: 'FAMILY_MEM_NAME',
      field: 'FAMILY_MEM_NAME',
      type: 'string',
      width: 158,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => <div>{params.value || '—'}</div>,

      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Family Member'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: 132,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'ADDRESS',
      accessor: 'ADDRESS',
      type: 'string',
      flex: 1,
      minWidth: 210,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => {
        const address = [params.row.ADDRESS, params.row.CITY, params.row.STATE]
          .filter((value) => value && String(value).trim())
          .join(', ');
        return <div title={address || 'Not available'}>{address || '—'}</div>;
      },
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Address'}
        </div>
      ),
    },

    {
      field: 'COMPANY_NAME',
      accessor: 'COMPANY_NAME',
      type: 'string',
      width: 152,
      headerAlign: 'center',
      align: 'left',
      renderCell: (params) => <div>{params.value || '—'}</div>,

      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Company Name'}
        </div>
      ),
    },

    {
      field: 'TOTAL',
      accessor: 'TOTAL',
      type: 'string',
      width: 120,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => (
        <div>₹{FormatNumber2(Number(params.value) || 0)}</div>
      ),
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Total'}
        </div>
      ),
    },
    {
      field: 'ADVANCE_AMT',
      accessor: 'ADVANCE_AMT',
      type: 'string',
      width: 136,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => (
        <div>₹{FormatNumber2(Number(params.value) || 0)}</div>
      ),
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Advance Amount'}
        </div>
      ),
    },
    {
      field: 'DISCOUNT_AMOUNT',
      accessor: 'DISCOUNT_AMOUNT',
      type: 'string',
      width: 128,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => (
        <div>₹{FormatNumber2(Number(params.value) || 0)}</div>
      ),
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Discount'}
        </div>
      ),
    },
    {
      field: 'GTOTAL',
      accessor: 'GTOTAL',
      type: 'string',
      width: 136,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => (
        <div className="pr-4">
          {' '}
          ₹{FormatNumber2(Number(params.value) || 0)}{' '}
        </div>
      ),
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Net Amount'}
        </div>
      ),
    },
    viewBillColumn,
  ];

  const columnsMobile = [
    {
      field: 'INVNO',
      type: 'number',
      width: width * 14,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex text-center">
          {' '}
          {'Invoice'}
        </div>
      ),
    },
    {
      field: 'BOOKING_ORDER_NO',
      type: 'number',
      width: width * 14,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex text-center">
          {' '}
          {'B.ID'}
        </div>
      ),
    },

    {
      field: 'CUSTOMER_NAME',
      type: 'string',
      width: width * 28,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Customer Name'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      type: 'string',
      width: width * 22,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'Mobile'}</div>,
    },

    {
      field: 'GTOTAL',
      type: 'string',
      width: width * 17,
      align: 'right',
      headerAlign: 'center',
      renderCell: (params) => (
        <div> {params.value ? FormatNumber2(params.value) : null} </div>
      ),
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Net Amt.'}</div>
      ),
    },
    viewBillColumn,
  ];

  const loadVocherAPI = (invNo) => {
    const data = {
      table_prefix: prefix,
      FDATE: firstDate,
      TDATE: SecondDate,
      MOBILE: customerInfo.mobile,
    };

    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/billing/billSummary`, data)
      .then(async function (response) {
        if (!response.data.error) {
          console.log(response.data.response);
          setList(response.data.response);
        }
      })
      .catch(function (error) {
        if (error?.response?.data?.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const navigate = useNavigate();

  const printRef = useRef();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState('print');
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize <= 800;
  const gridColumns = windowSize <= 500 ? columnsMobile : columns;
  const grossAmount = list.reduce(
    (total, row) => total + (Number(row.TOTAL) || 0),
    0
  );
  const advanceAmount = list.reduce(
    (total, row) => total + (Number(row.ADVANCE_AMT) || 0),
    0
  );
  const discountAmount = list.reduce(
    (total, row) => total + (Number(row.DISCOUNT_AMOUNT) || 0),
    0
  );
  const netAmount = list.reduce(
    (total, row) => total + (Number(row.GTOTAL) || 0),
    0
  );
  const taxAmount = Math.max(
    0,
    netAmount + advanceAmount - grossAmount + discountAmount
  );
  const tableHeight = Math.min(460, Math.max(180, 112 + list.length * 42));

  const handlePrint = useReactToPrint({
    content: () =>
      selectedPrintOption === 'print'
        ? printRef.current
        : thermalPrintRef.current,
    pageStyle: `
      @page { size: A4 landscape; margin: 10mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
    onAfterPrint: () => {
      navigate('/bill_summary');
      setSelectedPrintOption('print');
    },
  });

  const summaryCards = [
    {
      label: 'Total Bills',
      value: list.length,
      detail:
        list.length === 1 ? '1 invoice found' : `${list.length} invoices found`,
      icon: 'bi-receipt',
      tone: 'text-[#f08a4b]',
      iconBg: 'bg-[#fff2e8]',
    },
    {
      label: 'Gross Amount',
      value: `₹${FormatNumber2(grossAmount)}`,
      detail: 'Before discount and taxes',
      icon: 'bi-wallet2',
      tone: 'text-[#8dbb28]',
      iconBg: 'bg-[#f1f8df]',
    },
    {
      label: 'Advance Received',
      value: `₹${FormatNumber2(advanceAmount)}`,
      detail: 'Advance collected',
      icon: 'bi-check2-circle',
      tone: 'text-[#f5874f]',
      iconBg: 'bg-[#fff0e7]',
    },
    {
      label: 'Net Amount',
      value: `₹${FormatNumber2(netAmount)}`,
      detail: taxAmount
        ? `Includes ₹${FormatNumber2(taxAmount)} tax`
        : 'Final billed amount',
      icon: 'bi-cash-stack',
      tone: 'text-[#a6405c]',
      iconBg: 'bg-[#fbe8ed]',
    },
  ];

  return (
    <div
      className={`flex h-full min-h-0 min-w-0 w-full flex-col overflow-x-hidden bg-[#fff9f6] p-3 ${
        isMobile ? 'overflow-y-auto' : 'overflow-y-hidden'
      }`}
    >
      <div className="mb-3 grid shrink-0 grid-cols-2 gap-3 xl:grid-cols-4">
        {summaryCards.map((card) => (
          <div
            key={card.label}
            className="flex min-w-0 items-center rounded-md border border-[#eadbd4] bg-white px-4 py-3 shadow-[0_2px_8px_rgba(31,45,61,0.04)]"
          >
            <div
              className={`mr-3 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${card.iconBg} ${card.tone}`}
            >
              <i className={`bi ${card.icon}`}></i>
            </div>
            <div className="min-w-0">
              <div className="truncate text-xs font-medium text-[#6b6260]">
                {card.label}
              </div>
              <div className={`truncate text-lg font-bold ${card.tone}`}>
                {card.value}
              </div>
              <div className="truncate text-[11px] text-[#8b7f7a]">
                {card.detail}
              </div>
            </div>
          </div>
        ))}
      </div>
      {isMobile ? (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDateMobile
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-[30px] items-center justify-center gap-2 rounded-md border border-[#f5874f] px-4 text-sm font-semibold text-[#f5874f] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            setCustomerInfo={setCustomerInfo}
            reset={() => {
              setCustomerInfo({
                customer_name: '',
                mobile: '',
              });
            }}
            bookingCustomerDetails={customerInfo}
          />
        </div>
      ) : (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDate
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={() => {
              loadVocherAPI();
            }}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-[#f5874f] px-5 text-sm font-semibold text-[#f5874f] transition hover:bg-[#fff2eb] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setCustomerInfo({
                customer_name: '',
                mobile: '',
              });
            }}
            bookingCustomerDetails={customerInfo}
            reportLayout
          />
        </div>
      )}
      <div
        className={`mt-3 flex min-h-0 min-w-0 flex-col max-sm:mt-2 ${
          isMobile ? 'shrink-0' : 'flex-1'
        }`}
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: tableHeight } : undefined}
          >
            <DataGrid
            sx={{
              height: '100%',
              width: '100%',
              minWidth: 0,
              borderRadius: '6px',
              backgroundColor: 'white',
              border: '1px solid #eadbd4',
              fontSize: 14,
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f8e4dc',
                color: '#383535',
                borderBottom: '2px solid #f5874f',
              },
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#f8e4dc',
                borderRight: '1px solid #eadbd4',
              },
              '& .MuiDataGrid-columnHeader:last-of-type': {
                borderRight: '0',
              },
              '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 700,
                fontSize: '12px',
                letterSpacing: '0.025em',
                overflow: 'visible',
                textOverflow: 'clip',
              },
              '& .super-app-theme--header': {
                backgroundColor: '#f8e4dc',
              },
              '& .MuiDataGrid-cell': {
                borderRight: '1px solid #f0e3dd',
                borderBottom: '1px solid #f5ebe6',
                color: '#4b4545',
              },
              '& .MuiDataGrid-cell:last-of-type': {
                borderRight: '0',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#fff2eb',
              },
              '& .MuiDataGrid-row:nth-of-type(even)': {
                backgroundColor: '#fffaf7',
              },
              '& .MuiDataGrid-footerContainer': {
                borderTop: '1px solid #eadbd4',
                color: '#6b6260',
              },
              '& .MuiDataGrid-virtualScroller': {
                overflowX: 'auto',
                overflowY: 'auto',
                overscrollBehavior: 'contain',
              },
            }}
            rowHeight={42}
            headerHeight={46}
            columns={gridColumns}
            rows={list}
            pagination
            scrollbarSize={8}
            getRowId={(e) => e.INVNO}
            rowsPerPageOptions={[100]}
            experimentalFeatures={{ newEditingApi: true }}
            showCellRightBorder={true}
            showColumnRightBorder={true}
            disableColumnSelector
            disableColumnReorder
            disableColumnMenu={true}
            components={{
              NoRowsOverlay: () => (
                <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                  <i className="bi bi-receipt mb-2 text-2xl opacity-60"></i>
                  <span className="font-medium">No bills found</span>
                  <span className="mt-1 text-xs">
                    Change the date range or customer and apply the filter.
                  </span>
                </div>
              ),
            }}
            />
          </div>

          <div className="mt-2 min-w-0 shrink-0 overflow-x-auto rounded-md border border-[#eadbd4] bg-white">
            <div
              className="grid min-h-[48px] min-w-[1740px] items-center text-sm"
              style={{
                gridTemplateColumns:
                  '76px 104px 124px 168px 158px 132px minmax(210px, 1fr) 152px 120px 136px 128px 136px 96px',
              }}
            >
              {Array.from({ length: 7 }).map((_, index) => (
                <div
                  key={index}
                  className="h-full border-r border-[#f0e3dd]"
                ></div>
              ))}
              <div className="flex h-full items-center justify-end border-r border-[#f0e3dd] px-3 text-xs font-bold text-[#514946]">
                Column Totals
              </div>
              <div className="flex h-full items-center justify-end border-r border-[#f0e3dd] px-3 font-bold text-[#7aa51e]">
                ₹{FormatNumber2(grossAmount)}
              </div>
              <div className="flex h-full items-center justify-end border-r border-[#f0e3dd] px-3 font-bold text-[#dc6f39]">
                ₹{FormatNumber2(advanceAmount)}
              </div>
              <div className="flex h-full items-center justify-end border-r border-[#f0e3dd] px-3 font-bold text-[#f08a4b]">
                ₹{FormatNumber2(discountAmount)}
              </div>
              <div className="flex h-full items-center justify-end px-3 font-bold text-[#7f3048]">
                ₹{FormatNumber2(netAmount)}
              </div>
              <div className="h-full"></div>
            </div>
          </div>
        </div>

      </div>
      <CustomerMasterhelp
        onRowClick={(params) => {
          if (customerMasterModalStatus) {
            customerDetails(params);
          }
          dispatch(setCustomerMasterHelpModStatus(false));
        }}
      />
      <div>
        <div className="hidden">
          {selectedPrintOption === 'print' && windowSize ? (
            <div
              ref={printRef}
              style={{ display: 'block', visibility: 'hidden' }}
            >
              <PrintBillSummary
                data={list}
                firstDate={firstDate}
                SecondDate={SecondDate}
                bookingCustomerDetails={customerInfo}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default BillSummery;
